module.exports = __webpack_public_path__ + "img/2上传结构.610af2cb.gif";